import { render, staticRenderFns } from "./FileJavascriptIcon.vue?vue&type=template&id=f4742a44&scoped=true&"
import script from "./FileJavascriptIcon.vue?vue&type=script&lang=js&"
export * from "./FileJavascriptIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4742a44",
  null
  
)

export default component.exports